import {
  CREATE_INSPECTION,
  FETCH_INSPECTION,
  CLEAR_INSPECTION,
  CREATE_INSPECTION_ANSWER,
  FETCH_INSPECTION_LIST,
  FETCH_INSPECTION_ANSWER_LIST,
  FETCH_INSPECTION_ANSWER,
  CLEAR_INSPECTION_ANSWER,
  CLEAR_ACTION_RESULT,
  FETCH_INSPECTION_FOR_EDIT,
  DISCARD_INSPECTION_DRAFT,
  SEARCH_USER,
  CREATE_REMARK,
  FETCH_SAFETY_SELF_INSPECTION,
  EXPORT_INSPECTION,
  FETCH_TEMPLATES,
  FETCH_TEMPLATE,
  EXPORT_INSPECTION_DATA,
  FETCH_SUMMARY,
  CREATE_DRAFT_INSPECTION_ANSWER,
  FETCH_DRAFT_INSPECTION,
  CLEAR_OPEN_WORKORDERS,
  FETCH_OPEN_WORKORDERS,
  FETCH_DATA_SOURCES,
  FETCH_DATA_SOURCE_VALUES,
  CLEAR_ACTION_DATA_SOURCE,
  FORM_ANSWERS_LIST,
  FORMS_PUBLISHED_LIST,
  FETCH_CHECKLIST_ATTACHMENTS,
  CLEAR_LOADING_ACTIONS,
  PUBLISHED_FORM,
  CLEAR_REMARK,
  FETCH_SHIFT_TYPES,
  DELETE_REMARK,
  REMOVE_REMARK,
  HANGAR_INSPECTION_ANSWERS_LIST
} from './types';

const BACKEND_API = 'BACKEND_API';

export const fetchFormAnswers = () => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: '/portal_inspections/inspection_answer_list/',
    ...FORM_ANSWERS_LIST
  }
});

export const getAllPublishedFormList = () => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: '/portal_inspections/get_published_inspections/',
    ...FORMS_PUBLISHED_LIST
  }
});

export const clearFormActions = () => ({
  type: CLEAR_LOADING_ACTIONS
});

export const fetchPortalInspection = id => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/portal_inspections/${id}/`,
    ...PUBLISHED_FORM
  }
});

export const getChecklistAttachments = id => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: `/edit_inspections/${id}/get_checklist_attachments/`
    },
    FETCH_CHECKLIST_ATTACHMENTS
  )
});

export const addInspection = inspData => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: '/edit_inspections/',
    data: inspData,
    ...CREATE_INSPECTION
  }
});

export const editInspection = inspData => ({
  type: BACKEND_API,
  payload: {
    method: 'patch',
    url: `/edit_inspections/${inspData.id}/`,
    data: inspData,
    ...CREATE_INSPECTION
  }
});

export const fetchTemplates = () => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: '/inspection_templates/'
    },
    FETCH_TEMPLATES
  )
});

export const fetchTemplate = id => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: `/inspection_templates/${id}/`
    },
    FETCH_TEMPLATE
  )
});

export const updateTemplateVersion = id => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'POST',
      url: `/inspection_templates/${id}/update_version/`
    },
    FETCH_TEMPLATE
  )
});

export const updateInspectionVersion = id => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'POST',
      url: `/edit_inspections/${id}/update_template/`
    },
    FETCH_INSPECTION_FOR_EDIT
  )
});

export const fetchInspection = id => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/inspections/${id}/`,
    ...FETCH_INSPECTION
  }
});

export const fetchSafetySelfInspection = () => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: '/inspections/safety_self_inspection/',
    ...FETCH_SAFETY_SELF_INSPECTION
  }
});

export const fetchInspectionForEdit = id => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/edit_inspections/${id}/`,
    ...FETCH_INSPECTION_FOR_EDIT
  }
});

export const exportInspection = id => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/inspection_template/${id}/inspection/`,
    ...EXPORT_INSPECTION
  }
});

export const exportInspectionData = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `/inspection_template_data/${id}/inspection_data/`,
    ...EXPORT_INSPECTION_DATA
  }
});

export const discardInspectionDraft = id => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    url: `/edit_inspections/${id}/discard_draft/`,
    ...DISCARD_INSPECTION_DRAFT
  }
});

export const clearInspection = () => ({
  type: CLEAR_INSPECTION
});

export const clearRemark = () => ({
  type: CLEAR_REMARK
});

export const fetchInspectionList = query => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/inspections/${query ? '?query=' : ''}${query || ''}`,
    ...FETCH_INSPECTION_LIST
  }
});

export const fetchsummary = () => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: '/inspections/summary',
    ...FETCH_SUMMARY
  }
});

export const fetchInspectionListForEdit = () => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: '/edit_inspections/',
    ...FETCH_INSPECTION_LIST
  }
});

export const fetchDraftInspection = id => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    url: `/portal_inspections/${id}/start_portal_inspection/`,
    ...FETCH_DRAFT_INSPECTION
  }
});

export const fetchInspectionAnswers = (day, day2, query, result1, result2, shifts, result3) => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/inspection_answers/?s=${day}&f=${day2}${query ? '&query=' : ''}${query || ''}
      ${result2 ? '&filters=' : ''}${result2 || ''}${result1 ? '&issues=' : ''}${result1 || ''}
      ${shifts? '&shifts=':''}${shifts || ''}${result3 ? '&fields=' : ''}${result3 || ''}`,
    ...FETCH_INSPECTION_ANSWER_LIST
  }
});

export const completeInspection = (id, answers) => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: `/portal_inspections/${id}/create_inspection_answer/`,
    data: answers,
    ...CREATE_INSPECTION_ANSWER
  }
});

export const draftInspection = (id, answers) => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: `/inspections/${id}/save_draft_inspection/`,
    data: answers,
    ...CREATE_DRAFT_INSPECTION_ANSWER
  }
});

export const createRemark = data => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: '/remarks/',
    data,
    ...CREATE_REMARK
  }
});

export const editRemark = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'put',
    url: `/remarks/${id}/`,
    data,
    ...CREATE_REMARK
  }
});

export const deleteRemark = (id, aid) => ({
  type: BACKEND_API,
  payload: {
    method: 'delete',
    url: `/remarks/${id}/`,
    remarkId: id,
    id,
    aid,
    ...DELETE_REMARK
  }
});

export const remove_remark = id => ({
  type: REMOVE_REMARK,
  remarkId: id,
  id
});

export const searchUser = (query, perm) => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/users/?q=${query}&r=${perm}`,
    ...SEARCH_USER
  }
});


export const fetchInspectionAnswer = (id, from_hangar) => ({
  type: BACKEND_API,
  payload: {
    id,
    method: 'get',
    url: `/portal_inspections/${id}/inspection_answer_detail/?from_hangar=${from_hangar}`,
    ...FETCH_INSPECTION_ANSWER
  }
});

export const fetchShiftTypes = () => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: '/shift_types/'
    },
    FETCH_SHIFT_TYPES
  )
});

export const fetchOpenWorkOrders = wdate => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/work_orders/${wdate ? '?wdate=' : ''}${wdate || ''}`,
    ...FETCH_OPEN_WORKORDERS
  }
});

export const fetchDataSourceList = () => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: '/data_source/',
    ...FETCH_DATA_SOURCES
  }
});

export const fetchDataSoureValues = (methodName, data, Source_url, id, filters) => ({
  type: BACKEND_API,
  actionId: id,
  payload: {
    method: methodName,
    data,
    url: `${Source_url}${filters ? `?filters=${encodeURIComponent(JSON.stringify(filters))}` : ''}`,
    id,
    ...FETCH_DATA_SOURCE_VALUES
  }
});

export const fetchHangarInspectionAnswers = () => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: '/portal_inspections/hangar_inspection_answer_list/',
    ...HANGAR_INSPECTION_ANSWERS_LIST
  }
});

export const clearInspectionAnswer = () => ({
  type: CLEAR_INSPECTION_ANSWER
});

export const clearActionResult = () => ({
  type: CLEAR_ACTION_RESULT
});

export const clearOpenWorkOrders = () => ({
  type: CLEAR_OPEN_WORKORDERS
});

export const clearDataSourceValues = () => ({
  type: CLEAR_ACTION_DATA_SOURCE
});
